import { useTranslation } from 'react-i18next';

import { GroupEventsByDate } from './GroupEventsByDate';
import { EmptyWrapper, EmojiWrapper, Wrapper } from './UpcomingEvents.styles';

import { useWidgetNextEvents } from '@/store';

export const UpcomingEvents = () => {
  const { groupedEventsByDate } = useWidgetNextEvents();
  const { t } = useTranslation('StudentCourseSummaryTranslations');

  return (
    <Wrapper>
      {groupedEventsByDate && groupedEventsByDate.length > 0 ? (
        <>
          <GroupEventsByDate events={groupedEventsByDate} />
        </>
      ) : (
        <EmptyWrapper>
          <EmojiWrapper>
            <span role="img" aria-label="computer">
              🧑‍💻
            </span>
          </EmojiWrapper>
          <div>{t('NO_LIVE_EVENTS')}</div>
        </EmptyWrapper>
      )}
    </Wrapper>
  );
};
